// Nevades — pagination par points de la galerie produit (carrousel mobile).
// Les points reflètent la slide visible ; masqués en desktop via CSS.
(() => {
  "use strict";
  const gal = document.querySelector("[data-lightbox-gallery]");
  if (!gal) return;
  const slides = Array.from(gal.querySelectorAll("button[data-lightbox-trigger]"));
  if (slides.length < 2) return;

  const dots = document.createElement("div");
  dots.className = "nv-gallery-dots";
  dots.setAttribute("aria-hidden", "true");
  slides.forEach(() => dots.appendChild(document.createElement("span")));
  gal.insertAdjacentElement("afterend", dots);

  const setActive = (i) => {
    Array.from(dots.children).forEach((d, k) => d.classList.toggle("is-active", k === i));
  };
  setActive(0);

  // Slide majoritairement visible → point actif.
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) setActive(slides.indexOf(en.target));
        });
      },
      { root: gal, threshold: 0.6 }
    );
    slides.forEach((s) => io.observe(s));
  }

  // Secours : position de scroll.
  const onScroll = () => {
    const step = slides[0].offsetWidth + 12; // largeur slide + gap
    setActive(Math.min(slides.length - 1, Math.max(0, Math.round(gal.scrollLeft / Math.max(1, step)))));
  };
  gal.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
})();
